import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mas-garantia-footer',
  templateUrl: './mas-garantia-footer.component.html',
  styleUrls: ['./mas-garantia-footer.component.scss']
})
export class MasGarantiaFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
